import 'bootstrap';

//styles
import '../sass/main.scss';

//utils
import './utils/imagesImport';
import './utils/hamburgerMenu';
import './utils/select';
import navbar from './utils/navbar';
import smoothscroll from 'smoothscroll-polyfill';
import headerSlider from './pages/homepage/headerSlider';
import opinionSwiper from './pages/homepage/opinionSwiper';
import brandSwiper from './pages/homepage/brandSwiper';
import animations from './utils/animations';
smoothscroll.polyfill();

window.addEventListener('DOMContentLoaded', () => {
    //utils
    navbar();
    animations();
    //pages
    headerSlider();
    opinionSwiper();
    brandSwiper();
});
